<mat-form-field class="client-name">
  <mat-label>{{ label }}</mat-label>
  <input [formControl]="control" [matAutocomplete]="clientAuto" [placeholder]="placeholder" matInput type="text">
  <mat-error *ngIf="control.hasError('required')">
    field <strong>required</strong>
  </mat-error>
</mat-form-field>
<mat-autocomplete #clientAuto="matAutocomplete" (optionSelected)="onOptionSelected($event)"
                  class="equipment-catalog-autocomplete" panelWidth="440px">
  <mat-option *ngFor="let client of filteredClients | async" [id]="client.id" [value]="client.name">
    <span>{{ client.name }}</span>
  </mat-option>
</mat-autocomplete>
